module.exports = __webpack_public_path__ + "static/media/Team_07.2138a644.png";